import type { ConceptTask, Graph } from "@lr-notitia/notitia-designer/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const conceptTasks = (graph: Ref<Graph>) =>
	computed<ConceptTask[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "task" && node.layer === "concept"
			) as ConceptTask[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology || {} })
				.toLocaleLowerCase()
				.localeCompare(symbolsStore.term({ id: b.refersTo, terminology: b.terminology || {} }).toLocaleLowerCase())
		);
	});
export function conceptTask(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
	};
}

function byId(id: string, graph: Ref<Graph>): ConceptTask | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.type === "task" && hit.layer === "concept" ? (hit as ConceptTask) : undefined;
}
